module.exports = __webpack_public_path__ + "img/seawave-bg.9f976bd5.png";